import { LOG_NETWORK_REQUEST, LOG_NETWORK_RESPONSE } from 'actions/actionConstants'
import { createAppReducer } from 'lib/redux/reducerUtils'
import uuidV4 from '../lib/string/uuidV4Utils'
import { take } from 'lib/array/arrayUtils'

export const initialSherLogState: App.SherLogState = {
  traceId: uuidV4(),
  logData: [],
}

const sherlogReducer = createAppReducer<App.SherLogState>(initialSherLogState, {

  [LOG_NETWORK_REQUEST]: (state, action) => ({
    ...state,
    logData: take([...state.logData, action.request], 100),
  }),
  [LOG_NETWORK_RESPONSE]: (state, action) => {
    const logData = state.logData.map((log) => {
      if (log.requestName === action.response.requestName) {
        return {
          ...log,
          responseBody: action.response.responseBody,
          status: action.response.status,
        }
      }
      return log
    })

    return {
      ...state,
      logData: take(logData, 100),
    }
  },
})

export default sherlogReducer
